import * as React from 'react'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'

import { Divider } from './divider'
import { HtmlContent } from './html-content'

export function GameInfoSeoContent(props) {
  if (props.content?.__html) {
    return null
  }

  return (
    <Common.Box p={2}>
      <Divider />
      <Common.Box
        pt={2}
        maxWidth="1080px"
        margin="0 auto"
        textAlign="left"
        fontSize={2}
      >
        <HtmlContent html={props.content} />
      </Common.Box>
    </Common.Box>
  )
}

GameInfoSeoContent.propTypes = {
  content: PropTypes.shape({ __html: PropTypes.string }),
}
